import { render, staticRenderFns } from "./SearchStaff.vue?vue&type=template&id=3104e5f6&scoped=true"
import script from "./SearchStaff.vue?vue&type=script&lang=js"
export * from "./SearchStaff.vue?vue&type=script&lang=js"
import style0 from "./SearchStaff.vue?vue&type=style&index=0&id=3104e5f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3104e5f6",
  null
  
)

export default component.exports